import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ViewToggle = ({ currentView, onViewChange, resultsCount }) => {
  return (
    <div className="flex items-center justify-between gap-4 flex-wrap">
      <div className="flex items-center gap-2">
        <Icon name="Search" size={20} color="var(--color-primary)" />
        <p className="text-sm text-muted-foreground">
          <span className="font-semibold text-foreground">{resultsCount}</span> opportunities found
        </p>
      </div>

      <div className="flex items-center gap-2">
        <Button
          variant={currentView === 'grid' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onViewChange('grid')}
          iconName="Grid3x3"
          iconPosition="left"
        >
          Grid
        </Button>
        <Button
          variant={currentView === 'list' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onViewChange('list')}
          iconName="List"
          iconPosition="left"
        >
          List
        </Button>
        <Button
          variant={currentView === 'map' ? 'default' : 'outline'}
          size="sm"
          onClick={() => onViewChange('map')}
          iconName="Map"
          iconPosition="left"
        >
          Map
        </Button>
      </div>
    </div>
  );
};

export default ViewToggle;